import {makeStyles} from '@material-ui/core'
import theme from 'theme'

const useDialogComponentStyles = makeStyles(() => ({
  dialog: {
    width: 512,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '40px 48px 24px',
  },
  dialogButtonsWrapper: {
    padding: 24,
    gap: 24,
    '&.MuiDialogActions-spacing > :not(:first-child)': {
      margin: 0,
    },
  },
  title: {
    lineHeight: '34px',
    fontSize: 24,
    fontWeight: 400,
  },
  subTitleExtra: {
    margin: '16px 0',
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 700,
  },
  description: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
  },
  divider: {
    backgroundColor: theme.palette.customGrey.lightUL,
  },
}))

export default useDialogComponentStyles
